export const STATE_HEADER_HEIGHT = 36;
export const STEP_ITEM_HEIGHT = 36;
export const WAIT_STEP_HEIGHT = 36;
export const SPACER_HEIGHT = 4;
